import { Action } from 'redux';
import { Map } from 'immutable';

import {
    RESTAURANT_REQUEST,
    RESTAURANT_RESPONSE,
    RESTAURANT_ERROR,
    
    TOGGLE_FOOD_FILTER,
    RESET_FOOD_FILTER,
    SET_FOOD_FILTER,

    RESTAURANTS_LIST_REQUEST,
    RESTAURANTS_LIST_RESPONSE,
    RESTAURANTS_LIST_ERROR,
    
    SET_INPUT_VALUE,

    SET_CITY_VALUE,

    CITIES_REQUEST,
    CITIES_RESPONSE,
    CITIES_ERROR,
    
    SET_CITY,

    RESTAURANTS_LIST_TAG_REQUEST,
    RESTAURANTS_LIST_TAG_RESPONSE,
    RESTAURANTS_LIST_TAG_ERROR,
    
    COMPILATIONS_REQUEST,
    COMPILATIONS_RESPONSE,
    COMPILATIONS_ERROR,

    COMPILATION_REQUEST,
    COMPILATION_RESPONSE,
    COMPILATION_ERROR,

    GET_TIMES_REQUEST,
    GET_TIMES_RESPONSE,
    GET_TIMES_ERROR,

    GET_FILTER_TAGS_REQUEST,
    GET_FILTER_TAGS_RESPONSE,
    GET_FILTER_TAGS_ERROR,
    
    RESTAURANTS_MORE_LIST_TAG_REQUEST,
    RESTAURANTS_MORE_LIST_TAG_RESPONSE,
    RESTAURANTS_MORE_LIST_TAG_ERROR
} from '../../actions/Food/restaurants';

import { Restaurant } from '../../models/Food/Restaurant';
import { City } from '../../models/Food/City';
import { Compilation } from '../../models/Food/Compilation';
import { Tag } from '../../models/Food/Tag';
import { TagCategory } from '../../models/Food/TagCategory';

export interface RestaurantsState {
    restaurant: Restaurant;
    restaurants: Map<number, Restaurant>;
    restaurantsList: Map<number, Restaurant>;

    tags: Map<string, Tag>;
    filterTags: Map<string, TagCategory>;
    filters: Map<number, Tag>;

    city: number;
    cities: Array<City>;
    compilations: Array<Compilation>;
    tagsCompilations: Array<Compilation>;
    compilation: Map<number, Restaurant>;

    workingHours: Array<string>;

    loading: boolean;
    loadingList: boolean;
    loadingFilterTags: boolean;
    loadingCities: boolean;
    loadingTimes: boolean;

    error: string;

    inputValue: string;  
    cityValue: string;

    noResult: boolean;   

    page: number;

    restCount: number;
}

const initialState: RestaurantsState = {
    restaurant: {} as Restaurant,
    restaurants: Map<number, Restaurant>(),
    restaurantsList: Map<number, Restaurant>(),

    tags: Map<string, Tag>(),
    filterTags: Map<string, TagCategory>(),
    filters: Map<number, Tag>(),

    city: -1,
    cities: Array<City>(),

    compilation: Map<number, Restaurant>(),
    compilations: Array<Compilation>(),
    tagsCompilations: Array<Compilation>(),

    workingHours: Array<string>(),

    loading: false,
    loadingList: false,
    loadingFilterTags: false,
    loadingCities: false,
    loadingTimes: false,

    error: '',

    inputValue: '',
    cityValue: '',

    noResult: false,  

    page: 1,

    restCount: 0
};

export function restaurants(state: RestaurantsState = initialState, action: Action) {
    switch (action.type) {
        case COMPILATION_REQUEST: {
            return {
                ...state,
                loading: true,
                compilation: initialState.compilation
            };
        }
        case COMPILATION_RESPONSE: {
            const results = (action as any).response.result;
            const list = results.restaurants;
            let compilation = Map<number, Compilation>();
            list.forEach((l: Compilation) => {
                compilation = compilation.set(l.id, l);
            });
            return {
                ...state,
                loading: false,
                compilation
            };
        }
        case COMPILATION_ERROR: {
            const err = (action as any).error;
            return {
                ...state,
                error: err.code + err.description,
                loading: false
            };
        }

        case SET_INPUT_VALUE: {
            const {newValue} = (action as any);
            if (newValue.length && newValue.trim().length) {
                return {
                    ...state,
                    inputValue: newValue
                };
            }
            return {
                ...state,
                inputValue: newValue,
                restaurants: initialState.restaurants,
                tagsCompilations: initialState.tagsCompilations,
                noResult: initialState.noResult
            };
        }

        case SET_CITY: {
            const city = (action as any).newValue;
            return {
                ...state,
                city,
                compilations: initialState.compilations,
                tagsCompilations: initialState.tagsCompilations
            };
        }

        case SET_CITY_VALUE: {
            const cityValue = (action as any).newValue;
            return {
                ...state,
                cityValue
            };
        }

        case RESET_FOOD_FILTER: {
            return {
                ...state,
                filters: initialState.filters
            };
        }

        case TOGGLE_FOOD_FILTER: {
            const resp = (action as any);
            const tag = resp.tag;
            let filters = state.filters;
            const indexTag = filters.get(tag.id);
            if (indexTag) {
                filters = filters.delete(Number(tag.id));
            } else {
                filters = filters.set(Number(tag.id), tag);
            }
            return {
                ...state,
                filters
            };
        }

        case SET_FOOD_FILTER: {
            const resp = (action as any);
            const tag = resp.tag;
            const filters = state.filters.set(Number(tag.id), tag);
            return {
                ...state,
                filters
            };
        }

        case RESTAURANT_REQUEST: {
            return {
                ...state,
                loading: true,
                restaurant: initialState.restaurant
            };
        }
        case RESTAURANT_RESPONSE: {
            const resp = (action as any).response;
            const restaurant = (resp.result as Restaurant);
            return {
                ...state,
                restaurant,
                loading: false
            };
        }
        case RESTAURANT_ERROR: {
            const err = (action as any).error.error;
            return {
                ...state,
                error: err.code + err.desc,
                loading: false
            };
        }

        case RESTAURANTS_LIST_TAG_REQUEST: {
            return {
                ...state,
                error: initialState.error,
                loadingList: true
            };
        }
        case RESTAURANTS_LIST_TAG_RESPONSE: {
            const resp = (action as any).response;
            const result = (resp.result as Restaurant[]);
            const restaurantsList = result.reduce((prev, cur, key, arr) => {
                return prev.set(cur.id, cur);
            }, Map<number, Restaurant>());
            const page = resp.page.next_page;
            const restCount = resp.page.total_count;
            return {
                ...state,
                restaurantsList,
                loadingList: false,
                page,
                restCount
            };
        }
        case RESTAURANTS_LIST_TAG_ERROR: {
            const err = (action as any).error;
            return {
                ...state,
                error: err,
                loadingList: false
            };
        }

        case RESTAURANTS_MORE_LIST_TAG_REQUEST: {
            return {
                ...state,
                error: initialState.error,
                loading: true
            };
        }
        case RESTAURANTS_MORE_LIST_TAG_RESPONSE: {
            const resp = (action as any).response;
            const result = (resp.result as Restaurant[]);
            const restaurantsList = result.reduce((prev, cur, key, arr) => {
                return prev.set(cur.id, cur);
            }, state.restaurantsList);
            const page = resp.page.next_page;
            const restCount = resp.page.total_count;
            return {
                ...state,
                restaurantsList,
                loading: false,
                page,
                restCount
            };
        }
        case RESTAURANTS_MORE_LIST_TAG_ERROR: {
            const err = (action as any).error;
            return {
                ...state,
                error: err,
                loading: false
            };
        }

        case RESTAURANTS_LIST_REQUEST: {
            return {
                ...state,
                error: initialState.error,
                loading: true,
                noResult: initialState.noResult,
                restaurants: initialState.restaurants
            };
        }
        case RESTAURANTS_LIST_RESPONSE: {
            const resp = (action as any).response;
            const results = resp.result; 
            const noResult: boolean = !results.restaurants.length && !results.kitchen.length && !results.type.length && !results.compilations.length;
            let list = results.restaurants.reduce((prev: any, cur: any, key: number, arr: any) => {
                return prev.set(cur.id, cur);
            }, Map<number, any>());
            const kitchen = results.kitchen;
            const type = results.type;
            const tagsCompilations = results.compilations;
            let tags: Map<string, Tag> = Map<string, Tag>();
            tags = tags.set('кухни', kitchen);
            tags = tags.set('тип заведения', type);
            return {
                ...state,
                restaurants: list,
                noResult,
                tags,
                loading: false,
                tagsCompilations
            };
        }
        case RESTAURANTS_LIST_ERROR: {
            const err = (action as any).error;
            return {
                ...state,
                error: err,
                loading: false
            };
        }

        case COMPILATIONS_REQUEST: {
            return {
                ...state,
                error: initialState.error,
                loadingList: true,
                compilations: initialState.compilations
            };
        }
        case COMPILATIONS_RESPONSE: {
            const compilations = (action as any).response;
            return {
                ...state,
                compilations: compilations.valueSeq().toArray(),
                loadingList: false
            };
        }
        case COMPILATIONS_ERROR: {
            const err = (action as any).error;
            return {
                ...state,
                error: err,
                loadingList: false
            };
        }

        case CITIES_REQUEST: {
            return {
                ...state,
                error: initialState.error,
                loadingCities: true,
                cities: initialState.cities
            };
        }
        case CITIES_RESPONSE: {
            const resp = (action as any).response;
            const result = (resp.result as City[]);
            const cities = result.reduce((prev, cur, key, arr) => {
                prev.push(cur);
                return prev;
            }, Array<City>());
            return {
                ...state,
                cities,
                noResult: initialState.noResult,
                loadingCities: false
            };
        }
        case CITIES_ERROR: {
            const err = (action as any).error;
            return {
                ...state,
                error: err,
                loadingCities: false
            };
        }

        case GET_TIMES_REQUEST: {
            return {
                ...state,
                loadingTimes: true,
                workingHours: initialState.workingHours
            };
        }
        case GET_TIMES_RESPONSE: {
            const resp = (action as any).response;
            return {
                ...state,
                loadingTimes: false,
                workingHours: resp.result
            };
        }
        case GET_TIMES_ERROR: {
            const err = (action as any).error;
            return {
                ...state,
                error: err,
                loadingTimes: false
            };
        }

        case GET_FILTER_TAGS_ERROR: {
            const err = (action as any).error;
            return {
                ...state,
                error: err,
                loadingFilterTags: false
            };
        }
        
        case GET_FILTER_TAGS_REQUEST: {
            return {
                ...state,
                error: initialState.error,
                loadingFilterTags: true,
                filterTags: initialState.filterTags
            };
        }
        case GET_FILTER_TAGS_RESPONSE: {
            const filterTags = (action as any).response.result.reduce((prev: any, cur: any, key: number, arr: any) => {
                return prev.set(cur.id, cur);
            }, Map<number, TagCategory>());
            return {
                ...state,
                loadingFilterTags: false,
                filterTags
            };
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/Food/restaurants.ts